import React from "react";

export function SectionHeading({ eyebrow, title, subtitle, light = false, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {eyebrow && (
        <div className={`eyebrow mb-3 ${light ? "text-gold" : "text-crimson"}`}>{eyebrow}</div>
      )}
      <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-serif font-semibold leading-tight text-balance ${light ? "text-white" : "text-charcoal"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${light ? "text-platinum" : "text-slate-600"}`}>
          {subtitle}
        </p>
      )}
      <div className={`gold-line mt-6 w-24 ${center ? "mx-auto" : ""}`} />
    </div>
  );
}
